var Format;
(function (Format) {
    Format["Decimal"] = "Decimal";
    Format["DegMin"] = "DegMin";
    Format["DegMinSec"] = "DegMinSec";
})(Format || (Format = {}));
export { Format };
